/**
 * MET (Metriek) Module Seeds - DDD Canonical Location
 *
 * Incremental migration: reviewed seeds import from ./ (DDD),
 * remaining seeds still reference ../../data/seeds/MET/ (legacy).
 *
 * Reviewed & migrated (14 maart 2026):
 * - MET-OPP-DRIEHOEK ✅ (5 vragen, checklist passed)
 * - MET-MEETK-OPP ✅ (5 vragen, 2 nieuw, checklist passed)
 * - MET-OPP-SAMENGESTELD ✅ (5 vragen, 4 nieuw, checklist passed)
 * - MET-LEN-OMREKEN ✅ (8 vragen, fill_in uitleg verrijkt, checklist passed)
 * - MET-HOEK-SOORTEN ✅ (6 vragen, 1 nieuw, cognitief niveau + contexten + distractors geüpgraded, checklist passed)
 * - MET-MEETK-OMTREK ✅ (6 vragen, 1 fill_in nieuw, citoDifficulty spread verbreed, checklist passed)
 * - MET-COORDINATEN ✅ (6 vragen, 1 fill_in nieuw, checklist passed)
 * - MET-INH-OMREKEN ✅ (5 vragen, support text gefixt, stimulus visuals + contexten toegevoegd, checklist passed)
 * - MET-SCHAAL-BASIS ✅ (5 vragen, uitleg verrijkt, checklist passed)
 *
 * Reviewed & migrated (14 maart 2026 — batch 2):
 * - MET-OPP-PARALLELLOGRAM ✅ (5 vragen, geo stimulus visuals + uitleg verrijkt, checklist passed)
 * - MET-INH-OMREKEN-KUBIEK ✅ (5 vragen, stimulusAids + solutionSteps gefixt, checklist passed)
 * - MET-HOEK-BEREKENEN ✅ (6 vragen, 1 nieuw context Q006, stimulus aids + steps verrijkt, checklist passed)
 * - MET-GEW-OMREKEN ✅ (8 vragen, distractors gevarieerd, citoDifficulty deduped, uitleg verrijkt, checklist passed)
 * - MET-SCHAAL-LENGTE ✅ (5 vragen, BUG FIX Q003 dubbel correct antwoord, stimulus aid Q001, checklist passed)
 * - MET-MEETK-CIRKEL-DEEL ✅ (5 vragen, acceptedAnswers uitgebreid, checklist passed)
 *
 * Reviewed & migrated (14 maart 2026 — batch 3):
 * - MET-DRIEHOEK-SOORTEN ✅ (5 vragen, Q001 citoDifficulty↑ + explanationText verrijkt, Q005 distractorExplanations toegevoegd, checklist passed)
 * - MET-OPP-RECHT ✅ (5 vragen, geen fixes nodig, checklist passed)
 * - MET-OPP-OMREKENEN ✅ (5 vragen, Q001+Q004 solutionSteps uitgebreid naar ≥3, checklist passed)
 * - MET-INH-BLOK ✅ (5 vragen, citoDifficulty spread gedifferentieerd 0.25-0.36, checklist passed)
 * - MET-SYMMETRIE ✅ (5 vragen, Q004 citoDifficulty 0.48→0.43 voor B7 alignment, checklist passed)
 * - MET-SCHAAL-OPP ✅ (6 vragen, 4 NIEUW: direct calc, reverse, fill_in, large factor. Was 2 vragen — nu compleet, checklist passed)
 *
 * Reviewed & migrated (14 maart 2026 — batch 4):
 * - MET-GEW-CONTEXT ✅ (5 vragen, Q001+Q004 explanationText verrijkt met WAAROM+check, Q004 citoDifficulty 0.28→0.32, checklist passed)
 * - MET-GEW-SCHATTEN ✅ (5 vragen, Q004 citoDifficulty 0.30→0.35 voor spread ≥0.10, checklist passed)
 * - MET-HOEK-METEN ✅ (5 vragen, Q001+Q003 HERSCHREVEN (overlap HOEK-SOORTEN→meetprocedure), Q005 solutionSteps+explanationText verrijkt, citoDifficulty spread verbreed 0.25-0.42, checklist passed)
 * - MET-HOEK-TEKENEN ✅ (5 vragen, Q002 HERSCHREVEN (overlap HOEK-SOORTEN→tekenprocedure stomp), Q001+Q005 explanationText verrijkt, checklist passed)
 * - MET-INH-LITER ✅ (5 vragen, 2 NIEUW: Q004 ml→dl + Q005 fill_in l→ml. Was 3 vragen — nu compleet, citoDifficulty spread 0.25-0.40, checklist passed)
 * - MET-LEN-CONTEXT ✅ (5 vragen, Q002 explanationText+solutionSteps verrijkt met WAAROM+check, checklist passed)
 * - MET-MEETK-DIAMETER ✅ (5 vragen, Q001+Q002 solutionSteps uitgebreid met check, citoDifficulty spread verbreed 0.22-0.35, checklist passed)
 * - MET-OPP-VIERKANT ✅ (5 vragen, Q004 BUG FIX acceptableAnswers→acceptedAnswers, Q003 conceptId verduidelijkt, Q005 solutionSteps+check, checklist passed)
 *
 * Reviewed & migrated (14 maart 2026 — batch 5):
 * - MET-GEW-WEGEN ✅ (5 vragen, citoDifficulty 0.10-0.18→0.18-0.32 (was below minimum), explanationText verrijkt met WAAROM, distractors naar DENKFOUT format, Q005 MC→fill_in, checklist passed)
 * - MET-INH-SCHATTEN ✅ (5 vragen, citoDifficulty spread 0.05→0.13 (0.22-0.35), explanationText+solutionSteps verrijkt, distractors naar DENKFOUT→CORRECTIE→ONTHOUDEN format, checklist passed)
 * - MET-LEN-METEN ✅ (5 vragen, Q001+Q002 numberline stimulus visuals toegevoegd, Q005 acceptedAnswers uitgebreid, explanationText verrijkt met WAAROM, checklist passed)
 * - MET-LEN-SCHATTEN ✅ (5 vragen, Q005 BUG FIX missing citoDiscrimination+stimulusAids+supportAids, citoDifficulty spread 0.07→0.15 (0.20-0.35), checklist passed)
 * - MET-OMTREK-RECHT ✅ (5 vragen, 4 NIEUW: context (tuinier), terugrekenen, vierkant, fill_in (schilderij). Was 1 vraag — nu compleet, citoDifficulty spread 0.20-0.35, checklist passed)
 * - MET-OPP-LAND ✅ (5 vragen, 4 NIEUW: ha→m², m²→are, ha→km², fill_in m²→ha. Was 1 vraag — nu compleet, citoDifficulty spread 0.32-0.45, checklist passed)
 *
 * Reviewed & migrated (14 maart 2026 — batch 6, FINAL):
 * - MET-INH-CITER ✅ (5 vragen, 3 NIEUW: dl→cl, ml→cl, fill_in dl→cl. Was 2 vragen — nu compleet, citoDifficulty spread 0.30-0.45, explanationText verrijkt met WAAROM+CHECK, checklist passed)
 * - MET-LEN-NAUWKEURIG ✅ (5 vragen, BUG FIX stairs schema unit:"lengte"→type:"length", citoDifficulty spread 0.22-0.35, explanationText verrijkt met WAAROM+CHECK, checklist passed)
 * - MET-TIJD-METEN ✅ (5 vragen, Q002+Q004 HERSCHREVEN: kennisvragen→toepassingsvragen, explanationText verrijkt, checklist passed)
 * - MET-TIJD-NAUWKEURIG ✅ (5 vragen, Q004 HERSCHREVEN: decimalen tellen→afronden op honderdsten, citoDifficulty Q003 0.28→0.32 + Q004 0.25→0.38, checklist passed)
 *
 * ✅ ALL 38 MET FAMILIES NOW IN DDD — Migration complete!
 *
 * See docs/SEED_REVIEW_CHECKLIST.md §H for full migration process.
 */

// ── Reviewed seeds (DDD location) ──────────────────────────────────────────
import MET_OPP_DRIEHOEK from './MET-OPP-DRIEHOEK.json'
import MET_MEETK_OPP from './MET-MEETK-OPP.json'
import MET_OPP_SAMENGESTELD from './MET-OPP-SAMENGESTELD.json'
import MET_LEN_OMREKEN from './MET-LEN-OMREKEN.json'
import MET_HOEK_SOORTEN from './MET-HOEK-SOORTEN.json'
import MET_MEETK_OMTREK from './MET-MEETK-OMTREK.json'
import MET_COORDINATEN from './MET-COORDINATEN.json'
import MET_INH_OMREKEN from './MET-INH-OMREKEN.json'
import MET_SCHAAL_BASIS from './MET-SCHAAL-BASIS.json'
// Batch 2 (14 maart 2026)
import MET_OPP_PARALLELLOGRAM from './MET-OPP-PARALLELLOGRAM.json'
import MET_INH_OMREKEN_KUBIEK from './MET-INH-OMREKEN-KUBIEK.json'
import MET_HOEK_BEREKENEN from './MET-HOEK-BEREKENEN.json'
import MET_GEW_OMREKEN from './MET-GEW-OMREKEN.json'
import MET_SCHAAL_LENGTE from './MET-SCHAAL-LENGTE.json'
import MET_MEETK_CIRKEL_DEEL from './MET-MEETK-CIRKEL-DEEL.json'
// Batch 3 (14 maart 2026)
import MET_DRIEHOEK_SOORTEN from './MET-DRIEHOEK-SOORTEN.json'
import MET_OPP_RECHT from './MET-OPP-RECHT.json'
import MET_OPP_OMREKENEN from './MET-OPP-OMREKENEN.json'
import MET_INH_BLOK from './MET-INH-BLOK.json'
import MET_SYMMETRIE from './MET-SYMMETRIE.json'
import MET_SCHAAL_OPP from './MET-SCHAAL-OPP.json'
// Batch 4 (14 maart 2026)
import MET_GEW_CONTEXT from './MET-GEW-CONTEXT.json'
import MET_GEW_SCHATTEN from './MET-GEW-SCHATTEN.json'
import MET_HOEK_METEN from './MET-HOEK-METEN.json'
import MET_HOEK_TEKENEN from './MET-HOEK-TEKENEN.json'
import MET_INH_LITER from './MET-INH-LITER.json'
import MET_LEN_CONTEXT from './MET-LEN-CONTEXT.json'
import MET_MEETK_DIAMETER from './MET-MEETK-DIAMETER.json'
import MET_OPP_VIERKANT from './MET-OPP-VIERKANT.json'
// Batch 5 (14 maart 2026)
import MET_GEW_WEGEN from './MET-GEW-WEGEN.json'
import MET_INH_SCHATTEN from './MET-INH-SCHATTEN.json'
import MET_LEN_METEN from './MET-LEN-METEN.json'
import MET_LEN_SCHATTEN from './MET-LEN-SCHATTEN.json'
import MET_OMTREK_RECHT from './MET-OMTREK-RECHT.json'
import MET_OPP_LAND from './MET-OPP-LAND.json'
// Batch 6 — FINAL (14 maart 2026)
import MET_INH_CITER from './MET-INH-CITER.json'
import MET_LEN_NAUWKEURIG from './MET-LEN-NAUWKEURIG.json'
import MET_TIJD_METEN from './MET-TIJD-METEN.json'
import MET_TIJD_NAUWKEURIG from './MET-TIJD-NAUWKEURIG.json'

const MET_FAMILY_SEEDS = [
  // ✅ REVIEWED — DDD location (batch 1)
  { file: 'src/content/seeds/MET/MET-LEN-OMREKEN.json', data: MET_LEN_OMREKEN },
  // ✅ REVIEWED — DDD location (batch 5)
  { file: 'src/content/seeds/MET/MET-LEN-METEN.json', data: MET_LEN_METEN },
  {
    file: 'src/content/seeds/MET/MET-LEN-SCHATTEN.json',
    data: MET_LEN_SCHATTEN,
  },
  // ✅ REVIEWED — DDD location (batch 2)
  { file: 'src/content/seeds/MET/MET-GEW-OMREKEN.json', data: MET_GEW_OMREKEN },
  // ✅ REVIEWED — DDD location (batch 5)
  { file: 'src/content/seeds/MET/MET-GEW-WEGEN.json', data: MET_GEW_WEGEN },
  // ✅ REVIEWED — DDD location (batch 4)
  {
    file: 'src/content/seeds/MET/MET-GEW-SCHATTEN.json',
    data: MET_GEW_SCHATTEN,
  },
  // ✅ REVIEWED — DDD location (batch 1)
  {
    file: 'src/content/seeds/MET/MET-HOEK-SOORTEN.json',
    data: MET_HOEK_SOORTEN,
  },
  // ✅ REVIEWED — DDD location (batch 3)
  { file: 'src/content/seeds/MET/MET-SYMMETRIE.json', data: MET_SYMMETRIE },
  // ✅ REVIEWED — DDD location (batch 1)
  { file: 'src/content/seeds/MET/MET-INH-OMREKEN.json', data: MET_INH_OMREKEN },
  // ✅ REVIEWED — DDD location (batch 5)
  {
    file: 'src/content/seeds/MET/MET-INH-SCHATTEN.json',
    data: MET_INH_SCHATTEN,
  },
  // ✅ REVIEWED — DDD location (batch 3)
  { file: 'src/content/seeds/MET/MET-OPP-RECHT.json', data: MET_OPP_RECHT },
  // ✅ REVIEWED — DDD location (batch 5)
  {
    file: 'src/content/seeds/MET/MET-OMTREK-RECHT.json',
    data: MET_OMTREK_RECHT,
  },
  // ✅ REVIEWED — DDD location (batch 1)
  {
    file: 'src/content/seeds/MET/MET-OPP-DRIEHOEK.json',
    data: MET_OPP_DRIEHOEK,
  },
  // ✅ REVIEWED — DDD location (batch 3)
  { file: 'src/content/seeds/MET/MET-INH-BLOK.json', data: MET_INH_BLOK },
  // ✅ REVIEWED — DDD location (batch 1)
  {
    file: 'src/content/seeds/MET/MET-OPP-SAMENGESTELD.json',
    data: MET_OPP_SAMENGESTELD,
  },
  // ✅ REVIEWED — DDD location (batch 4)
  { file: 'src/content/seeds/MET/MET-INH-LITER.json', data: MET_INH_LITER },
  // ✅ REVIEWED — DDD location (batch 5)
  { file: 'src/content/seeds/MET/MET-OPP-LAND.json', data: MET_OPP_LAND },
  // ✅ REVIEWED — DDD location (batch 6)
  { file: 'src/content/seeds/MET/MET-INH-CITER.json', data: MET_INH_CITER },
  // ✅ REVIEWED — DDD location (batch 1)
  {
    file: 'src/content/seeds/MET/MET-MEETK-OMTREK.json',
    data: MET_MEETK_OMTREK,
  },
  // ✅ REVIEWED — DDD location (batch 1)
  { file: 'src/content/seeds/MET/MET-MEETK-OPP.json', data: MET_MEETK_OPP },
  // ✅ REVIEWED — DDD location (batch 3)
  { file: 'src/content/seeds/MET/MET-SCHAAL-OPP.json', data: MET_SCHAAL_OPP },
  // ✅ REVIEWED — DDD location (batch 4)
  {
    file: 'src/content/seeds/MET/MET-OPP-VIERKANT.json',
    data: MET_OPP_VIERKANT,
  },
  // ✅ REVIEWED — DDD location (batch 1)
  { file: 'src/content/seeds/MET/MET-COORDINATEN.json', data: MET_COORDINATEN },
  // ✅ REVIEWED — DDD location (batch 3)
  {
    file: 'src/content/seeds/MET/MET-DRIEHOEK-SOORTEN.json',
    data: MET_DRIEHOEK_SOORTEN,
  },
  // ✅ REVIEWED — DDD location (batch 6)
  {
    file: 'src/content/seeds/MET/MET-LEN-NAUWKEURIG.json',
    data: MET_LEN_NAUWKEURIG,
  },
  // ✅ REVIEWED — DDD location (batch 4)
  { file: 'src/content/seeds/MET/MET-LEN-CONTEXT.json', data: MET_LEN_CONTEXT },
  { file: 'src/content/seeds/MET/MET-HOEK-METEN.json', data: MET_HOEK_METEN },
  // ✅ REVIEWED — DDD location (batch 1)
  {
    file: 'src/content/seeds/MET/MET-SCHAAL-BASIS.json',
    data: MET_SCHAAL_BASIS,
  },
  // ✅ REVIEWED — DDD location (batch 2)
  {
    file: 'src/content/seeds/MET/MET-OPP-PARALLELLOGRAM.json',
    data: MET_OPP_PARALLELLOGRAM,
  },
  // ✅ REVIEWED — DDD location (batch 4)
  { file: 'src/content/seeds/MET/MET-GEW-CONTEXT.json', data: MET_GEW_CONTEXT },
  {
    file: 'src/content/seeds/MET/MET-HOEK-TEKENEN.json',
    data: MET_HOEK_TEKENEN,
  },
  // ✅ REVIEWED — DDD location (batch 6)
  { file: 'src/content/seeds/MET/MET-TIJD-METEN.json', data: MET_TIJD_METEN },
  {
    file: 'src/content/seeds/MET/MET-TIJD-NAUWKEURIG.json',
    data: MET_TIJD_NAUWKEURIG,
  },
  // ✅ REVIEWED — DDD location (batch 2)
  {
    file: 'src/content/seeds/MET/MET-SCHAAL-LENGTE.json',
    data: MET_SCHAAL_LENGTE,
  },
  // ✅ REVIEWED — DDD location (batch 2)
  {
    file: 'src/content/seeds/MET/MET-HOEK-BEREKENEN.json',
    data: MET_HOEK_BEREKENEN,
  },
  // ✅ REVIEWED — DDD location (batch 4)
  {
    file: 'src/content/seeds/MET/MET-MEETK-DIAMETER.json',
    data: MET_MEETK_DIAMETER,
  },
  // ✅ REVIEWED — DDD location (batch 3)
  {
    file: 'src/content/seeds/MET/MET-OPP-OMREKENEN.json',
    data: MET_OPP_OMREKENEN,
  },
  // ✅ REVIEWED — DDD location (batch 2)
  {
    file: 'src/content/seeds/MET/MET-INH-OMREKEN-KUBIEK.json',
    data: MET_INH_OMREKEN_KUBIEK,
  },
  // ✅ REVIEWED — DDD location (batch 2)
  {
    file: 'src/content/seeds/MET/MET-MEETK-CIRKEL-DEEL.json',
    data: MET_MEETK_CIRKEL_DEEL,
  },
] as const

const allQuestions = MET_FAMILY_SEEDS.flatMap(({ file, data }) =>
  data.questions.map((question) => ({ ...question, __sourceFile: file })),
)

export default {
  module: 'Metriek' as const,
  moduleCode: 'MET',
  version: '5.9-ddd-complete',
  taxonomyVersion: '4.1',
  questions: allQuestions,
}
